<div class="breadcrumb-container" [ngClass]="{ 'breadcrumb-container-compact': compactSidebar }" id="breadcrumb">
  <div class="breadcrumb-component">
    <app-breadcrumb
      [parents]=breadcrumbParents
      [self]="breadcrumbSelf">
    </app-breadcrumb>
  </div>
</div>
<div class="breadcrumb-placeholder"></div>
<div class="container-horizontal-padding container-vertical-padding-half animated fadeIn">
  <form class="form-horizontal bordered-row" (ngSubmit)="createMasterDataRecord()" #f="ngForm" novalidate>
    <app-masterdata-record-base
      headingDictionaryKey="MASTERDATA_RECORD_PANEL_HEADING_CLONE"
      [readonly]="false"
      [allowClone]="false"
      [form]="f"
      (submitted)="submit($event)"></app-masterdata-record-base>
    <app-form-record-container
      [readonly]="false"
      [cloning]="true"
      [form]="f"></app-form-record-container>
  </form>
</div>
